import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import LibraryView from "@/views/LibraryView.vue";

const defaultTitle =
  "卖相炸裂627 我的生活不好-BV627全球唯一官方网站兼室长个人网站|BV627官方网站";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
      meta: {
        title: defaultTitle
      }
    },
    {
      path: "/about",
      name: "about",
      component: AboutView,
      meta: {
        title: `关于 | ${defaultTitle}`
      }
    },
    {
      path: "/library",
      name: "library",
      component: LibraryView,
      meta: {
        title: `资源库 | ${defaultTitle}`
      }
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/"
    }
  ]
});

router.afterEach((to) => {
  document.title = to.meta?.title || defaultTitle;
});

export default router;
